// 转办弹窗表单配置
export const complaintFormOption = {
    column: [
      
      {
        type: 'input',
        label: '服务项目',
        span: 12,
        display: true,
        disabled:true,
        formslot:true,
        prop: 'serviceItemId',

      },
      {
        type: 'select',
        label: '服务商',
        span: 12,
        disabled:false,
        // required:true,
        props:{
          label:'groupName',
          value:"id"
        },
        dicData:[],
        formslot:true,
        prop: 'serviceProviderId',
        rules:[{required:true,message:'请选择 服务商',trigger:'blur'}]
      },
      {
        type: 'select',
        label: '服务人员',
        span: 24,
        dicData:[],
        display: true,
        disabled:false,
        props:{
          label:'namePhone',
          value:"id"
        },
        formslot:true,
        prop: 'handerId',
        // rules:[{required:true,message:'请选择服务人员',trigger:'blur'}]
      },
      {
        type: 'textarea',
        label: '备注',
        span: 24,
        display: true,
        formslot:true,
        prop: 'remark',
        rules: [
          {
            required: false,
            message: '请输入备注'
          },
          { min: 0, max: 500, message: '请控制在500个字符内！', trigger: 'change' }],
      }
    ],
    labelPosition: 'right',
    labelSuffix: '：',
    labelWidth: 100,
    gutter: 0,
    menuBtn: true,
    submitBtn: true,
    submitText: '保 存',
    emptyBtn: false,
    menuPosition: 'right',
    detail: false,
    tabs: false
  };

  // 转办弹窗表单配置
export const complaintFormOption2 = {
  column: [
    {
      type: 'input',
      label: '服务项目',
      span: 12,
      display: true,
      disabled:true,
      formslot:true,
      prop: 'serviceItemId',

    },
    {
      type: 'select',
      label: '服务商',
      span: 12,
      disabled:false,
      // required:true,
      props:{
        label:'groupName',
        value:"id"
      },
      dicData:[],
      formslot:true,
      prop: 'serviceProviderId',
      rules:[{required:true,message:'请选择 服务商',trigger:'blur'}]
    },
    {
      type: 'select',
      label: '服务人员',
      span: 24,
      dicData:[],
      display: true,
      disabled:false,
      props:{
        label:'namePhone',
        value:"id"
      },
      formslot:true,
      prop: 'handerId',
      // rules:[{required:true,message:'请选择服务人员',trigger:'blur'}]
    },
    {
      type: 'textarea',
      label: '备注',
      span: 24,
      display: true,
      formslot:true,
      prop: 'remark',
      rules: [ {
        required: false,
        message: '请输入备注'
      },{ min: 0, max: 500, message: '请控制在500个字符内！', trigger: 'change' }],
    }
  ],
  labelPosition: 'right',
  labelSuffix: '：',
  labelWidth: 100,
  gutter: 0,
  menuBtn: true,
  submitBtn: true,
  submitText: '保 存',
  emptyBtn: false,
  menuPosition: 'right',
  detail: false,
  tabs: false
};

//   指派表单配置
export const assignFormOption={
    column: [
      {
        type: 'select',
        label: '服务班组',
        dicData: [
          {
            label: '选项一',
            value: 0
          },
          {
            label: '选项二',
            value: 1
          },
          {
            label: '选项三',
            value: 2
          }
        ],
        cascaderItem: [],
        span: 12,
        display: true,
        props: {
          label: 'label',
          value: 'value'
        },
        prop: '1603791027630_67658',
        disabled: true,
        required: true,
        rules: [
          {
            required: true,
            message: '请选择班组人员'
          }
        ]
      },
      {
        type: 'select',
        label: '转派人员',
        dicData: [
          {
            label: '选项一',
            value: 0
          },
          {
            label: '选项二',
            value: 1
          },
          {
            label: '选项三',
            value: 2
          }
        ],
        cascaderItem: [],
        span: 12,
        display: true,
        props: {
          label: 'label',
          value: 'value'
        },
        prop: '1603791074596_72702',
        rules: [
          {
            required: true,
            message: '请选择转派人员'
          }
        ],
        disabled: false,
        required: true
      },
      {
        type: 'textarea',
        label: '备注',
        span: 24,
        display: true,
        prop: '1604629243436_93844'
      }
    ],
    labelPosition: 'right',
    labelSuffix: '：',
    labelWidth: 100,
    gutter: 0,
    menuBtn: true,
    submitBtn: true,
    submitText: '保 存',
    emptyBtn: false,
    menuPosition: 'right',
    detail: false,
    tabs: false
  };


//  转单/接受表单配置

export const robOrderFormOption = {
    column: [
      // {
      //   type: 'select',
      //   label: '服务班组',
      //   dicUrl:'',
      //   formslot:true,
      //   span: 12,
      //   display: true,
      //   props: {
      //     label: 'label',
      //     value: 'value'
      //   },
      //   prop: '1603791027630_67658',
      //   disabled: true,
      //   required: true,
      //   rules: [
      //     {
      //       required: true,
      //       message: '请选择班组人员'
      //     }
      //   ]
      // },

      {
        type: 'textarea',
        label: '备注',
        span: 24,
        display: true,
        rules: [
              {
                required: true,
                message: '请输入备注'
              },
              { min: 0, max: 500, message: '请控制在500个字符内！', trigger: 'change' }
            ],
        formslot:true,
        prop: 'remark',

      }
    ],
    labelPosition: 'right',
    labelSuffix: '：',
    labelWidth: 100,
    gutter: 0,
    menuBtn: true,
    submitBtn: true,
    submitText: '保 存',
    emptyBtn: false,
    menuPosition: 'right',
    detail: false,
    tabs: false
  };

// 开始表单配置

export const startOrderFormOption={
    column: [
      {
        type: 'textarea',
        label: '备注',
        span: 24,
        display: true,
        formslot:true,
        prop: 'remark',

        required: true,
        rules: [
          {
            required: true,
            message: '请填写备注'
          },
          { min: 0, max: 500, message: '请控制在500个字符内！', trigger: 'change' }
        ]
      },
      {
        type: 'upload',
        label: '附件',
        span: 24,
        display: true,
        showFileList: true,
        multiple: true,
        limit: 10,
        dataType:'array',
        propsHttp: {},
        canvasOption: {},
        prop: 'attachList',
        formslot:true,
        drag: true,

      }
    ],
    labelPosition: 'right',
    labelSuffix: '：',
    labelWidth: 100,
    gutter: 0,
    menuBtn: true,
    submitBtn: true,
    submitText: '保 存',
    emptyBtn: false,

    menuPosition: 'right',
    detail: false,
    tabs: false
  }

// 取消表单配置
export const cancelFormOption = {
    column: [
      {
        type: 'textarea',
        label: '取消原因',
        span: 24,
        display: true,
        formslot:true,
        prop: 'remark',
        required: true,
        rules: [
          {
            required: true,
            message: '请填写备注'
          },
          { min: 0, max: 500, message: '请控制在500个字符内！', trigger: 'change' }
        ]

      },
      {
        type: 'upload',
        label: '附件',
        span: 24,
        display: true,
        showFileList: true,
        multiple: true,
        limit: 10,
        propsHttp: {},
        canvasOption: {},
        prop: 'attachList',
        fileSize: 500,
        formslot:true,

        drag: true,

      }
    ],
    labelPosition: 'right',
    labelSuffix: '：',
    labelWidth: 100,
    gutter: 0,
    menuBtn: true,
    submitBtn: true,
    submitText: '保 存',
    emptyBtn: false,
    emptyText: '清空',
    menuPosition: 'right',
    detail: false,
    tabs: false
  }

//   评价表单配置

export const evaluateFormOption = {
    column: [


      {
        type: 'textarea',
        label: '评价内容',
        span: 24,
        display: true,
        rules: [
         { min: 0, max: 500, message: '请控制在500个字符内！', trigger: 'change' }
        ],
        prop: 'remark'
      },
      {
        type: 'upload',
        label: '附件',
        span: 24,
        display: true,
        showFileList: true,
        multiple: true,
        limit: 10,
        propsHttp: {},
        canvasOption: {},
        prop: 'attachList',
        fileSize: 500,
        formslot:true,

        drag: true,

      }

    ],
    columnCopy: [


      {
        type: 'textarea',
        label: '评价内容',
        span: 24,
        display: true,
        rules: [
          { min: 0, max: 500, message: '请控制在500个字符内！', trigger: 'change' }
        ],
        prop: 'remark'
      },
      {
        type: 'upload',
        label: '附件',
        span: 24,
        display: true,
        showFileList: true,
        multiple: true,
        limit: 10,
        propsHttp: {},
        canvasOption: {},
        prop: 'attachList',
        fileSize: 500,
        formslot:true,

        drag: true,

      }

    ],
    labelPosition: 'right',
    labelSuffix: '：',
    labelWidth: 120,
    gutter: 0,
    menuBtn: true,
    submitBtn: true,
    submitText: '保 存',
    emptyBtn: false,
    emptyText: '清空',
    menuPosition: 'right',
    detail: false,
    tabs: false
  }


//   回访表单配置

export const visitFormOption = {
    column:[
      {
        type: 'select',
        label: '回访形式',
        prop: 'way',
        dicUrl:"/api/blade-system/dict/dictionary?code=return_visit_way",
        span: 12,
        display: true,
        props: {
          label: 'dictValue',
          value: 'dictKey'
        },

        rules: [
          {
            required: true,
            message: '请选择回访形式'
          }
        ],
        required: true
      },
      {
        type: 'select',
        label: '满意度',
        prop: 'satisfaction',
        dicUrl:"/api/blade-system/dict/dictionary?code=return_visit_satisfaction",
        cascaderItem: [],
        span: 12,
        display: true,
        props: {
          label: 'dictValue',
          value: 'dictKey'
        },

        rules: [
          {
            required: true,
            message: '请选择下满意度'
          }
        ],
        required: true
      },
    ],

    column1: [

      {
        type: 'select',
        label: '回访形式',
        prop: 'way',
        dicUrl:"/api/blade-system/dict/dictionary?code=return_visit_way",
        span: 12,
        display: true,
        props: {
          label: 'dictValue',
          value: 'dictKey'
        },

        rules: [
          {
            required: true,
            message: '请选择回访形式'
          }
        ],
        required: true
      },
      {
        type: 'select',
        label: '满意度',
        prop: 'satisfaction',
        dicUrl:"/api/blade-system/dict/dictionary?code=return_visit_satisfaction",
        cascaderItem: [],
        span: 12,
        display: true,
        props: {
          label: 'dictValue',
          value: 'dictKey'
        },

        rules: [
          {
            required: true,
            message: '请选择满意度'
          }
        ],
        required: true
      },
      {
        type: 'select',
        label: '服务标签',
        span: 12,
        row:true,
        dicData:[],
        props:{
          label:"dictValue",
          value:'dictKey'
        },
        multiple:true,
        display: true,
        prop: 'target'
      },

    ],
    column2: [
      {
        type: 'textarea',
        label: '回访内容',
        span: 24,
        formslot:true,
        display: true,
        prop: 'remark'
      }
    ],

    labelPosition: 'right',
    labelSuffix: '：',
    labelWidth: 120,
    gutter: 0,
    menuBtn: true,
    submitBtn: false,
    submitText: '保 存',
    emptyBtn: false,
    emptyText: '清空',
    menuPosition: 'right',
    detail: false,
    tabs: false
  }

  // 延迟
  export const delayFormOption = {
    labelPosition: 'right',
    labelSuffix: '：',
    labelWidth: 120,
    gutter: 0,
    menuBtn: true,
    submitBtn: true,
    submitText: '保 存',
    emptyBtn: false,
    emptyText: '清空',
    menuPosition: 'right',
    detail: false,
    tabs: false,
    column: [

      {
        type: 'textarea',
        label: '备注',
        span: 24,
        display: true,
        formslot:true,
        prop: 'remark',
        rules:[{required:true,message:'请输入备注'},{ min: 0, max: 500, message: '请控制在500个字符内！', trigger: 'change' }]
      },
      {
        type: 'input',
        label: '附件',
        span: 24,
        display: true,
        formslot:true,
        prop: 'attachList',



      }
    ],
  }

  // 恢复
  export const recoverFormOption = {
    labelPosition: 'right',
    labelSuffix: '：',
    labelWidth: 120,
    gutter: 0,
    menuBtn: true,
    submitBtn: true,
    submitText: '保 存',
    emptyBtn: false,
    emptyText: '清空',
    menuPosition: 'right',
    detail: false,
    tabs: false,
    column: [

      {
        type: 'textarea',
        label: '备注',
        span: 24,
        display: true,
        formslot:true,
        prop: 'remark',
        rules:[{required:true,message:'请输入备注'},{ min: 0, max: 500, message: '请控制在500个字符内！', trigger: 'change' }]
      },


    ],
  }


  // 完成 finishFormOption
  export const finishFormOption = {
    labelPosition: 'right',
    labelSuffix: '：',
    labelWidth: 120,
    gutter: 0,
    menuBtn: true,
    submitBtn: true,
    submitText: '完成',
    emptyBtn: false,
    emptyText: '清空',
    menuPosition: 'right',
    detail: false,
    tabs: false,
    column: [

      {
        type: 'textarea',
        label: '备注',
        span: 24,
        display: true,
        formslot:true,
        prop: 'remark',
        rules:[{required:true,message:'请输入备注'},{ min: 0, max: 500, message: '请控制在500个字符内！', trigger: 'change' }]
      },
      {
        type: 'input',
        label: '附件',
        span: 24,
        display: true,
        formslot:true,
        prop: 'attachList',


      }
    ],
  }
  // 报废 scrapFormOption
  export const scrapFormOption = {
    labelPosition: 'right',
    labelSuffix: '：',
    labelWidth: 120,
    gutter: 0,
    menuBtn: true,
    submitBtn: true,
    submitText: '保 存',
    emptyBtn: false,
    emptyText: '清空',
    menuPosition: 'right',
    detail: false,
    tabs: false,
    column: [

      {
        type: 'textarea',
        label: '备注',
        span: 24,
        display: true,
        formslot:true,
        prop: 'remark',
        rules:[{required:true,message:'请输入备注'},{ min: 0, max: 500, message: '请控制在500个字符内！', trigger: 'change' }]
      },
      {
        type: 'input',
        label: '附件',
        span: 24,
        display: true,
        formslot:true,
        prop: 'attachList',


      }
    ],
  }
 //外委 outsourcingFormOption
export const outsourcingFormOption = {
  labelPosition: 'right',
  labelSuffix: '：',
  labelWidth: 120,
  gutter: 0,
  menuBtn: true,
  submitBtn: true,
  submitText: '保 存',
  emptyBtn: false,
  emptyText: '清空',
  menuPosition: 'right',
  detail: false,
  tabs: false,
  column: [
    {
      type: 'select',
      label: '关联合同',
      span: 24,
      dicData:[],
      display: true,
      props:{
        label:'contractName',
        value:"contractId"
      },
      prop: 'contractId',
      rules:[{required:true,message:'请选择关联合同'}]
    },
    {
      type: 'select',
      label: '合同单位',
      span: 24,
      disabled:true,
      dicData:[],
      display: true,
      props:{
        label:'partnerName',
        value:"partnerId"
      },
      prop: 'partnerId',


    },
    {
      type: 'textarea',
      label: '备注',
      span: 24,
      display: true,
      formslot:true,
      prop: 'remark',
      rules:[{required:true,message:'请输入备注'},{ min: 0, max: 500, message: '请控制在500个字符内！', trigger: 'change' }]
    },
    {
      type: 'upload',
      label: '附件',
      span: 24,
      display: true,
      showFileList: true,
      multiple: true,
      limit: 10,
      dataType:'array',
      propsHttp: {},
      canvasOption: {},
      prop: 'attachList',
      formslot:true,
      drag: true,

    }

  ],
}
  // 报修
  export const repairsFormOption = {
  column: [
    // {
    //   type: 'select',
    //   label: '项目名称',
    //   formslot:true,
    //   span: 8,
    //   display: true,
    //   props: {
    //     label: 'label',
    //     value: 'value'
    //   },
    //   prop: 'projectId',
    //   required: true,
    //   rules: [
    //     {
    //       required: true,
    //       message: '请选择项目名称'
    //     }
    //   ]
    // },
    // {
    //   type: 'select',
    //   label: '需求区域',
    //   formslot:true,
    //   span: 12,

    //   display: true,
    //   prop: 'areaId',
    //   rules: [
    //     {
    //       required: true,
    //       message: '请选择需求区域'
    //     }
    //   ],
    //   required: true
    // },
    // {
    //   type: 'select',
    //   label: '需求人员',
    //   formslot:true,
    //   span: 12,
    //   display: true,
    //   props: {
    //     label: 'label',
    //     value: 'value'
    //   },
    //   prop: 'requireMainId',
    //   rules: [
    //     {
    //       required: true,
    //       message: '请选择需求人员'
    //     }
    //   ],
    //   required: true
    // },
    // {
    //   type: 'select',
    //   label: '需求来源',
    //   dataType:'string',
    //   span: 12,
    //   display: true,
    //   dicUrl:'/api/blade-system/dict/dictionary?code=order_require_source',
    //   props: {
    //     label: 'dictValue',
    //     value: 'dictKey'
    //   },
    //   prop: 'source',
    //   rules: [
    //     {
    //       required: true,
    //       message: '请选择需求人员'
    //     }
    //   ],
    //   required: true
    // },
    {
      type: 'datetime',
      label: '期望到场时间',
      span: 12,
      display: true,
      format: 'yyyy-MM-dd HH:mm:ss',
      valueFormat: 'yyyy-MM-dd HH:mm:ss',
      prop: 'expectStartTime',
      required: true,
      rules: [
        {
          required: true,
          message: '期望到场时间必须填写'
        }
      ]
    },
    {
      type: 'select',
      label: '紧急程度',
      dicUrl:'/api/blade-system/dict/dictionary?code=order_urgent_level',

      span: 12,
      display: true,
      props: {
        label: 'dictValue',
        value: 'dictKey'
      },
      prop: 'urgentLevel',
      required: true,
      rules: [
        {
          required: true,
          message: '请选择紧急程度'
        }
      ]
    },
    {
      type: 'select',
      label: '业务模块',
      dicData: [
        {
          label: '选项一',
          value: 0
        },
        {
          label: '选项二',
          value: 1
        },
        {
          label: '选项三',
          value: 2
        }
      ],
      cascaderItem: [],
      span: 12,
      display: false,
      props: {
        label: 'label',
        value: 'value'
      },
      prop: 'moduleJson',
      rules: []
    },
    {
      type: 'textarea',
      label: '工单描述',
      span: 24,
      display: true,
      prop: 'description',
      formslot:true,
      required: true,
      rules: [
        {
          required: true,
          message: '工单描述必须填写'
        },
        // { min: 0, max: 500, message: '请控制在500个字符内！', trigger: 'change' }
      ]
    },
    {
      type: 'input',
      label: '附件',
      span: 24,
      display: true,
      formslot:true,
      prop: 'attachList',


    }
  ],
  labelPosition: 'right',
  labelSuffix: '：',
  labelWidth: 120,
  gutter: 0,
  menuBtn: true,
  submitBtn: true,
  submitText: '提 交',
  emptyBtn: false,
  menuPosition: 'right',
  detail: false,
  tabs: false
}

//协同人
export const settingSynergyOption = {
  labelPosition: 'right',
    labelSuffix: '：',
    labelWidth: 120,
    gutter: 0,
    menuBtn: true,
    submitBtn: true,
    submitText: '保 存',
    emptyBtn: false,
    emptyText: '清空',
    menuPosition: 'right',
    detail: false,
    tabs: false,
    column: [
      // {
      //   type: 'select',
      //   label: '协同人',
      //   span: 24,
      //   display: true,
      //   formslot:true,
      //   prop: 'cheacked',


      // },
      {
        type: 'select',
        label: '设置协同人',
        span: 24,
        dicData:[],

        display: true,
        props:{
          label:'namePhone',
          value:"id"
        },
        prop: 'cooperateLists',
        multiple: true,
        rules:[{required:true,message:'请选择协同人'}]
      },

    ],
  }

  // 确认
  export const confirmOption = {
    labelPosition: 'right',
      labelSuffix: '：',
      labelWidth: 120,
      gutter: 0,
      menuBtn: true,
      submitBtn: true,
      submitText: '保 存',
      emptyBtn: false,
      emptyText: '清空',
      menuPosition: 'right',
      detail: false,
      tabs: false,
      column: [
        {
          type: 'select',
          label: '备注',
          span: 24,
          dicData:[],
          formslot:true,
          display: true,

          prop: 'remark',
          multiple: true,
          rules:[{required:true,message:'请输入备注'},{ min: 0, max: 500, message: '请控制在500个字符内！', trigger: 'change' }]
        },

      ],
    }

  // 确认
  export const urgeOption = {
    labelPosition: 'right',
      labelSuffix: '：',
      labelWidth: 120,
      gutter: 0,
      menuBtn: true,
      submitBtn: true,
      submitText: '保 存',
      emptyBtn: false,
      emptyText: '清空',
      menuPosition: 'right',
      detail: false,
      tabs: false,
      column: [
        {
          type: 'textarea',
          label: '备注',
          span: 24,
          // dicData:[],
          formslot:true,
          display: true,
          maxlength:500,

          prop: 'remark',
          // multiple: true,
          rules:[
            // {required:true,message:'请输入备注'},
          // { min: 0, max: 500, message: '请控制在500个字符内！', trigger: 'change' }
        ]
        },

      ],
    }

    // 催办
    export const pressOption = {
      labelPosition: 'right',
        labelSuffix: '：',
        labelWidth: 120,
        gutter: 0,
        menuBtn: true,
        submitBtn: true,
        submitText: '保 存',
        emptyBtn: false,
        emptyText: '清空',
        menuPosition: 'right',
        detail: false,
        tabs: false,
        column: [
          {
            type: 'select',
            label: '备注',
            span: 24,
            dicData:[],
            formslot:true,
            display: true,

            prop: 'remark',
            multiple: true,
            rules:[{required:true,message:'请输入备注'},{ min: 0, max: 500, message: '请控制在500个字符内！', trigger: 'change' }]
          },

        ],
      }


